(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slizzy-detail"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-image]');if(!button)return;const section=button.closest('.sv-detail');section.querySelector('[data-main-image]').src=button.dataset.image;section.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});
document.addEventListener('change',event=>{if(!event.target.matches('[data-preview-size]'))return;const section=event.target.closest('.sv-detail');section.querySelector('[data-size-status]').textContent=event.target.value;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slizzy-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
 const link = event.target.closest('[data-enquiry]');
 if (!link) return;
 const topic = document.getElementById('SlizzyTopic');
 if (topic) { topic.value = link.dataset.enquiry; topic.dispatchEvent(new Event('change', { bubbles: true })); }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slizzy-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{if(event.target.id!=='SlizzyVariant')return;const option=event.target.selectedOptions[0];const section=event.target.closest('.sv-product');section.querySelector('[data-product-price]').textContent=option.dataset.price;const button=section.querySelector('[data-add-button]');if(button)button.disabled=option.dataset.available!=='true';});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slizzy-shop"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-filter]');if(!button)return;const section=button.closest('.sv-shop');section.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));section.querySelectorAll('[data-category]').forEach(card=>{card.hidden=button.dataset.filter!=='all'&&card.dataset.category!==button.dataset.filter;});});

  } catch(e) { console.error(e); }
})();
})();
